import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import { setActivePage, setComparedEntity } from '../../actions/ui';
import { entityLabelMatcher } from "../../helpers/label-mapper"
import styles from './compare-select-entities.module.scss';
import Button from '../../components/button';
import Select from 'react-select';
import classNames from 'classnames';
class CompareSelectEntitiesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEntity: null,
        };
        this.goToEntityPage = this.goToEntityPage.bind(this);
        this.showComparison = this.showComparison.bind(this);
        this.getSelectOptions = this.getSelectOptions.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
    }
    goToEntityPage() {
        const { setActivePage } = this.props;
        setActivePage('entity');
    }

    showComparison() {
        const { setComparedEntity } = this.props;
        const { selectedEntity } = this.state;
        if (!selectedEntity) return;
        setComparedEntity(selectedEntity.value);
        this.goToEntityPage();
    }

    onSelectChange(council) {
        this.setState({ selectedEntity: council });
    }

    renderCouncils(councils) {
        const { selectedEntity } = this.state;
        return councils.map(council => {
            return (
                <div
                    key={council.id}
                    role="button"
                    onClick={e => {
                        this.setState({
                            selectedEntity: {
                                label: council.name,
                                value: council.id,
                            },
                        });
                    }}
                    className={classNames({
                        [styles.listItem]: true,
                        [styles.listItemActive]: selectedEntity
                            ? selectedEntity.value === council.id
                            : false,
                    })}
                >
                    {council.name}
                </div>
            );
        });
    }

    renderOtherCouncils() {
        const { entities, activeEntity } = this.props;
        const classificationCouncils = entities.filter(e => {
            return (
                e.id !== activeEntity.id &&
                e.entityCategory === activeEntity.entityCategory &&
                e.compare
            );
        });

        return (
            <div>
                <h4 className={styles.classificationHeadline}>
                    {activeEntity.entityCategory}
                </h4>
                <div className={styles.councilList}>
                    {this.renderCouncils(classificationCouncils)}
                </div>
            </div>
        );
    }

    renderCouncilList() {
        return this.renderOtherCouncils();
    }

    getSelectOptions() {
        const { entities, activeEntity } = this.props;
        return entities
            .filter(e => e.id !== activeEntity.id && e.compare)
            .map(e => {
                return {
                    label: e.name,
                    value: e.id,
                };
            });
    }

    renderSelect() {
        const { selectedEntity } = this.state;
        return (
            <div className={styles.councilSelect}>
                <Select
                    className="allOtherCouncilsDropdown red"
                    name="allOtherCouncilsDropdown"
                    placeholder={'Search for HHS'}
                    value={selectedEntity}
                    onChange={this.onSelectChange}
                    options={this.getSelectOptions()}
                    clearable={false}
                />
            </div>
        );
    }

    renderButtonRow() {
        const { selectedEntity } = this.state;
        return (
            <div className={styles.buttonsRow}>
                <button
                    type="button"
                    className={styles.backLink}
                    onClick={this.goToEntityPage}
                >
                    <img
                        className={styles.backLinkImage}
                        src={`${process.env.PUBLIC_URL}/img/close-icon.svg`}
                        alt="chevron icon"
                        style={{ width: 10, height: 10 }}
                    />
          close
        </button>
                <Button disabled={!selectedEntity} whenOnClick={this.showComparison}>
                    show comparison
        </Button>
            </div>
        );
    }

    render() {
        const { activeEntity } = this.props;
        return (
            <div className={styles.compareSelectPageWrapper}>
                {this.renderButtonRow()}
                <div className={styles.heading}>{activeEntity.name}</div>
                <h3 className={styles.chooseHeadline}>Choose a {entityLabelMatcher(activeEntity.entityCategory, 'singular').toLocaleLowerCase()} to compare</h3>
                <div className={styles.formWrapper}>
                    <form>
                        {this.renderCouncilList()}
                    </form>
                </div>
                {this.renderButtonRow()}
            </div>
        );
    }
}

const mapDispatchToProps = {
    setActivePage,
    setComparedEntity,
};

const mapStateToProps = state => ({
    activeEntity: selectors.getActiveEntity(state),
    entities: selectors.getEntities(state),
});

CompareSelectEntitiesPage.propTypes = {
    entities: PropTypes.arrayOf(PropTypes.object),
    activeEntity: PropTypes.object.isRequired,
    setActivePage: PropTypes.func.isRequired,
    setComparedEntity: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareSelectEntitiesPage);



// WEBPACK FOOTER //
// ./src/pages/compare-select-entities-page/compare-select-entities-page.js